/**
 * ▼▼▼ EDITÁ ACÁ TUS DATOS ▼▼▼
 * WHATSAPP_LINK: link corto de WhatsApp Business de VCARS.
 * Se usa en TODOS los botones de WhatsApp / contacto de la página.
 * (Este tipo de link no admite mensaje precargado: el texto del saludo
 *  se configura desde WhatsApp Business.)
 */
export const WHATSAPP_LINK = 'https://wa.me/message/YRVFDIQWAIUNM1'

export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/vcars',
  facebook: 'https://facebook.com/vcars',
  tiktok: 'https://tiktok.com/@vcars',
}

/**
 * Devuelve el link de WhatsApp para cualquier botón.
 * El parámetro `message` queda solo como referencia interna de la intención
 * de cada botón; el link es siempre el mismo.
 */
export function whatsappUrl(_message?: string): string {
  return WHATSAPP_LINK
}
